import {
  Box,
  Button,
  Divider,
  IconButton,
  Paper,
  Table,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material'
import { useTranslation } from 'react-i18next'
import { defaultCombinators } from 'react-querybuilder'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'
import DeleteIcon from '@mui/icons-material/Delete'
import TextInput from '../TextInput'
import SelectInput from '../SelectInput'
import CustomRule from '../CustomRule'
import { CATEGORIES } from '../../constantsV2'

const CustomGroup = (props) => {
  const { t } = useTranslation(['common', 'messages'])
  const { ruleGroup, actions, path, country } = props

  const handleGroupExtraChange = (key, value) => {
    actions.onPropChange(key, value, path)
  }

  const isRootGroup = path.length === 0

  return (
    <Box display="flex" alignItems="center" justifyContent="space-between">
      {!isRootGroup && (
        <Box width="13%" maxWidth="13%">
          <SelectInput
            value={ruleGroup.category || ''}
            onChange={(value) => handleGroupExtraChange('category', value)}
            options={CATEGORIES.map((category) => ({ label: category.label, value: category.value }))}
            emptyLabel={`${t('common:select')} ${t('common:category')}`}
            required
          />
        </Box>
      )}
      <Paper
        elevation={0}
        variant={isRootGroup ? 'root' : 'rootOutlined'}
        sx={{ width: isRootGroup ? '100%' : '66%', padding: 2, marginBottom: 2 }}
      >
        <Box display="flex" alignItems="center" gap="16px" mt=".5rem">
          {!isRootGroup && (
            <SelectInput
              value={ruleGroup.combinator}
              onChange={(value) => handleGroupExtraChange('combinator', value)}
              options={defaultCombinators}
              disabled={isRootGroup}
            />
          )}

          <Button
            variant="outlined"
            size="small"
            startIcon={<AddCircleOutlineIcon />}
            onClick={() => actions.onRuleAdd({ attribute: '', operator: '', value: '' }, path)}
          >
            Add Rule
          </Button>

          {isRootGroup && (
            <Button
              variant="outlined"
              size="small"
              startIcon={<AddCircleOutlineIcon />}
              onClick={() =>
                actions.onGroupAdd(
                  {
                    combinator: 'and',
                    rules: [],
                  },
                  path,
                )
              }
            >
              Add Group
            </Button>
          )}
        </Box>

        <Divider sx={{ marginY: 1 }} />

        {isRootGroup && (
          <>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell width="16%">{t('common:category')}</TableCell>
                  <TableCell width="27%">{t('common:attribute')}</TableCell>
                  <TableCell width="19%">{t('common:operator')}</TableCell>
                  <TableCell width="23%">{t('common:value')}</TableCell>
                  <TableCell width="15%">{t('common:score')}</TableCell>
                </TableRow>
              </TableHead>
            </Table>
          </>
        )}

        <Box display="flex" flexDirection="column" gap="16px" mt=".5rem">
          {ruleGroup.rules.map((ruleOrGroup, index) =>
            ruleOrGroup.rules ? (
              <CustomGroup
                {...props}
                key={`group-${path.join('-')}-${index}`}
                path={[...path, index]}
                ruleGroup={ruleOrGroup}
                country={country}
              />
            ) : (
              <CustomRule
                {...props}
                key={`rule-${path.join('-')}-${index}`}
                path={[...path, index]}
                rule={ruleOrGroup}
                country={country}
              />
            ),
          )}
        </Box>
      </Paper>
      {!isRootGroup && (
        <Box width="15%" display="flex" gap="8px" alignItems="center">
          <TextInput
            value={ruleGroup.score || ''}
            onChange={(value) => handleGroupExtraChange('score', Number(value))}
            type="number"
            placeholder={t('common:score')}
            required
          />
          <IconButton onClick={() => actions.onGroupRemove(path)} color="error">
            <DeleteIcon />
          </IconButton>
        </Box>
      )}
    </Box>
  )
}

export default CustomGroup
